function isValidSize(size) {
  return Number.isFinite(size?.width)
    && size.width > 0
    && Number.isFinite(size?.height)
    && size.height > 0;
}

export function readNodeLayoutSize(nodeRef, canvasScale = 1) {
  if (!nodeRef) return null;

  const declared = nodeRef.getLayoutSize?.();
  if (isValidSize(declared)) return declared;

  const element = nodeRef.getDOM?.();
  const offsetSize = {
    width: element?.offsetWidth,
    height: element?.offsetHeight,
  };
  if (isValidSize(offsetSize)) return offsetSize;

  const rect = nodeRef.getBoundingClientRect?.();
  const safeScale = Number.isFinite(canvasScale) && canvasScale > 0 ? canvasScale : 1;
  const measured = rect ? {
    width: rect.width / safeScale,
    height: rect.height / safeScale,
  } : null;
  return isValidSize(measured) ? measured : null;
}
